import React from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

import { HubContextMenu } from "../../components";
import { setIsOpenDialog } from "../../redux";

export const OutboundOrdersContextMenu = ({
  item,
  _setIsOpenDialog = () => {},
  setPoNumber = () => {},
  ...rest
}) => {
  const id = item?.id;
  const navigate = useNavigate();

  const MENU_ITEMS = [
    {
      id: "edit",
      label: "Edit Purchase Order",
      icon: "Edit",
    },
    ...[
      item?.shipDate
        ? {
            id: "finished",
            label: "Mark As Finished",
            icon: "Clock",
          }
        : {
            id: "started",
            label: "Mark As Started",
            icon: "Clock",
          },
    ],
    {
      id: "delete",
      label: "Delete",
      icon: "Trash2",
      color: "redError",
    },
  ];

  const onSelect = (selected) => {
    switch (selected?.id) {
      case "edit":
        navigate(`/orders/${id}`, id);
        break;
      case "finished":
      case "started":
        setPoNumber(item.poNumber);
      case "delete":
        break;
      default:
        break;
    }
  };

  return (
    <HubContextMenu
      id={"industries"}
      loading={false}
      menuItems={MENU_ITEMS}
      onSelect={onSelect}
      IconButtonProps={{ sx: { padding: 0 } }}
      {...rest}
    />
  );
};

const mapStateToProps = () => ({});
const mapDispatchToProps = {
  _setIsOpenDialog: setIsOpenDialog,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OutboundOrdersContextMenu);
